import {
  ColorPalette,
  ColorPickerIcon,
  type Props as ColorPaletteProps,
} from "@/components/color-palette/ColorPalette";

import type { Color } from "@corca/data";

type Props = ColorPaletteProps & {
  currentColor?: Color | null;
  iconClassName?: string;
};

export function TableCellBackgroundDropdown({
  currentColor = "white",
  iconClassName,
  ...props
}: Props) {
  return (
    <ColorPalette
      {...props}
      currentColor={currentColor}
      icon={<ColorPickerIcon color={currentColor} className={iconClassName} />}
    />
  );
}
